/**
 * Creates a page URL for routing
 * @param {string} pageName - The name of the page
 * @returns {string} - The URL path
 */
export function createPageUrl(pageName) {
  return `/${pageName}`;
}

/**
 * Utility function to combine classes (similar to clsx)
 * @param {...any} classes - Classes to combine
 * @returns {string} - Combined classes
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Generates a UUID v4
 * @returns {string} - UUID string
 */
export function generateUUID() {
  return crypto.randomUUID();
}

/**
 * Formats a date string
 * @param {string|Date} date - Date to format
 * @param {string} format - Format string (default: 'MMM d, yyyy')
 * @returns {string} - Formatted date
 */
export function formatDate(date, format = 'MMM d, yyyy') {
  // Simple date formatting - in production you'd use date-fns
  const d = new Date(date);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  if (format === 'MMM d, yyyy') {
    return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  }
  
  return d.toLocaleDateString();
}

/**
 * Formats a date-time into a specific IANA time zone (defaults to Australia/Sydney - AEST/AEDT).
 * @param {string|number|Date} date - Input date/time
 * @param {string} timeZone - IANA time zone, e.g. 'Australia/Sydney'
 * @param {Intl.DateTimeFormatOptions} opts - Additional Intl options
 */
export function formatDateTimeInTz(date, timeZone = 'Australia/Sydney', opts = {}) {
  const d = new Date(date);
  try {
    return new Intl.DateTimeFormat('en-AU', {
      timeZone,
      year: 'numeric', month: 'short', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false,
      ...opts,
    }).format(d);
  } catch {
    // Fallback if Intl/timeZone unsupported
    return d.toLocaleString('en-AU', { timeZone });
  }
}
